import { Box, Button, FormControl, FormControlLabel, Grid, InputBase, Radio, RadioGroup, TextField, Typography } from "@material-ui/core";
import React, {useState} from "react";
import { DialogPopup } from "../../components/DialogPopup";
import { DeviceFeedbackIcon, ResolveIcon, ThumpsUpIcon } from "src/components/Icons";
import useStyles from "src/app/maintenance/assets/styles";
import { optionConfig } from "src/app/utils";
import Cookies from "js-cookie";
import { updateAttemptedDevices, updateDiscardMessages } from "../../components/apiHelper";
import { is } from "date-fns/locale";
import { on } from "process";

export const FeedbackPopup = ({deviceId, rootCauseId, open, onClose, setIsToasterOpen, setToasterMessage, setReqSuccess, setLoading}) => {
    const classes = useStyles();
    const [step, setStep] = useState(1);
    const [selectedReason, setSelectedReason] = useState('');
    const [additionalFeedback, setAdditionalFeedback] = useState('');
    const [errors, setErrors] = useState({
        reason: false,
        additionalFeedback: false
    });

    const userId = Cookies.get('USER_ID');
    const referenceId = Cookies.get('ACCOUNT');

    const handleNoClick = async () => {
        const data = {
            referenceId: referenceId,
            userId: userId,
            device_id: deviceId,
            rootcause_id: rootCauseId,
            pop_up_status: 'discard',
        }

        const response = await updateAttemptedDevices(data);
        if (response.status === 200) {
            setErrors({ reason: false, additionalFeedback: false });
            setStep(2);   
        }
    };
    
    const handleBackClick = () => {
        setErrors({ reason: false, additionalFeedback: false });
        setStep(1);
    };

    const validateForm = () => {
        const newErrors = {
            reason: !selectedReason,
            additionalFeedback: false
        };

        const selectedOption = optionConfig.find(option => option.value === selectedReason);
        if (selectedOption && selectedOption.needsInput && !additionalFeedback.trim()) {
            newErrors.additionalFeedback = true;
        }

        setErrors(newErrors);
        return !newErrors.reason && !newErrors.additionalFeedback;
    };
    
    const handleSubmit = async () => {
        if (!validateForm()) return;

        const selectedOption = optionConfig.find(option => option.value === selectedReason);
        let reasonToSend = selectedReason;
        
        if (selectedOption.needsInput) {
            reasonToSend = `${selectedReason}_${additionalFeedback}`;
        }

        const data = {
            referenceId: referenceId,
            userId: userId,
            device_id: deviceId,
            rootcause_id: rootCauseId,
            discard_msg: reasonToSend
        };
        try {
            setLoading(true);
            const response = await updateDiscardMessages(data);
            if (response.status === 200) {
                setIsToasterOpen(true);
                setToasterMessage('Thank You For The Feedback');
                setReqSuccess(true);
                onClose(false);
            } else {
                setIsToasterOpen(true);
                setToasterMessage(response.data.message || 'Failed to submit feedback');
                setReqSuccess(false);
            }
        } catch (error) {
            setIsToasterOpen(true);
            setToasterMessage(error.message || 'An error occurred while submitting feedback');
            setReqSuccess(false);
        } finally {
            setLoading(false);
            setTimeout(() => setIsToasterOpen(false), 2000);
        }
    };

    const handleHelpfulClick = async () => {
        const data = {
            referenceId: referenceId,
            userId: userId,
            device_id: deviceId,
            rootcause_id: rootCauseId,
            pop_up_status: 'accept',
        }
        
        try {
            setLoading(true);
            const response = await updateAttemptedDevices(data);
            if (response.status === 200) {
                setIsToasterOpen(true);
                setToasterMessage('Thank You For The Feedback');
                setReqSuccess(true);
                onClose(false);
            } else {
                setIsToasterOpen(true);
                setToasterMessage(response.data.message || 'Failed to submit feedback');
                setReqSuccess(false);
            }
        } catch (error) {
            setIsToasterOpen(true);
            setToasterMessage(error.message || 'An error occurred while submitting feedback');
            setReqSuccess(false);
        } finally {
            setLoading(false);
            setTimeout(() => setIsToasterOpen(false), 2000);
        }
    }

    const dialogContent =
        step === 1 ? (
        <Grid container direction="column" alignItems="center" spacing={1}>
            <Grid item>
                <DeviceFeedbackIcon />
            </Grid>
            <Typography className={classes.feedBackTitle}>This {deviceId} device is now functioning correctly.</Typography>
            <Typography className={classes.feedBackSubTitle}>Was my guidance helpful in resolving the issue?</Typography>
            <Grid container className={classes.feedbackButtonContainer}>
            <Grid item style={{justifyItems: 'start'}}>
                <Button variant="outlined" className={classes.feedBackCancelButton} onClick={handleNoClick}>No, didn't help</Button>
            </Grid>
            <Grid item style={{alignContent:'center'}}>
                <Button variant="contained" className={classes.feedBackButton} onClick={handleHelpfulClick} startIcon={<ResolveIcon />}>Yes, it helped</Button>
            </Grid>
            </Grid>
        </Grid>
        ) : (
        <Grid container direction="column" alignItems="center" spacing={1}>
            <Grid item>
                <DeviceFeedbackIcon />
            </Grid>
            <Typography className={classes.feedBackTitle}>
            Sorry to hear that. I'm learning every day to serve you better.
            </Typography>
            <Typography className={classes.feedBackSubTitle}>
            Please let me know how I can improve:
            </Typography>
            <FormControl fullWidth style={{ marginTop: '20px' }}>
            <RadioGroup 
                value={selectedReason} 
                style={{ margin: '0px' }}
                onChange={(e) => {
                    setSelectedReason(e.target.value);
                    setErrors({...errors, reason: false});
                }}
            >
                {optionConfig.map((option) => (
                <React.Fragment key={option.value}>
                    <Box 
                    className={classes.radioOption} 
                    style={{
                        borderColor: selectedReason === option.value ? '#005B96' : '#E2E5ED'
                    }}
                    >
                    <FormControlLabel 
                        value={option.value} 
                        control={<Radio className={classes.feedBackRadio}/>} 
                        label={option.value}
                        style={{ 
                        width: '100%', 
                        color: selectedReason === option.value ? '#005B96' : '#000000' 
                        }}
                    />
                    </Box>
                    
                    {selectedReason === option.value && option.needsInput && (
                    <TextField
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        placeholder={option.placeholder}
                        value={additionalFeedback}
                        onChange={(e) => {
                            setAdditionalFeedback(e.target.value);
                            setErrors({...errors, additionalFeedback: false});
                        }}
                        style={{ marginBottom: "2px" }}
                        error={errors.additionalFeedback}
                        helperText={errors.additionalFeedback ? "This field is required" : ""}
                        InputProps={{
                            inputProps: {
                                style: {
                                    fontSize: '14px' 
                                }
                            },
                            classes: {
                                input: classes.inputPlaceholder
                            }
                        }}
                    />
                    )}
                </React.Fragment>
                ))}
            </RadioGroup>
            {errors.reason && (
                <Typography className="form-error">
                    Select a Reason is Required
                </Typography>
            )}
            </FormControl>
            <Grid container className={classes.feedbackButtonContainer}>
                <Grid item>
                    <Button variant="outlined" className={classes.feedBackCancelButton} onClick={handleBackClick}>Back</Button>
                </Grid>
                <Grid item style={{alignContent:'center'}}>
                    <Button variant="contained" className={classes.feedBackButton} onClick={handleSubmit} startIcon={<ThumpsUpIcon color='#FFFFFF' />}>Submit Feedback</Button>
                </Grid>
            </Grid>
        </Grid>
        );

    return (
        <DialogPopup
            open={open}
            onClose={() => onClose(true)}
            dialogWidth="550px"
            isFeedBack={true}
            dialogContent={dialogContent}
            buttonRequired={false}
            needsAdditionalPadding={step === 2 && selectedReason && optionConfig.find(o => o.value === selectedReason).needsInput}
        />
    );
};
